import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import identityDocuments from "../../../../../../media/images/icons/identityDocuments.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import DangerFill from "../../../../../../media/images/icons/danger-fill";
import DocumentCard from "./DocumentCard";
import CheckCircle from "../../../../../../media/images/icons/check-circle";

export default function IdentityDocuments() {
  const [isOpen, setIsOpen] = useState(false);

  const theme = useTheme();

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "column",
        border: "1px solid gray",
        borderRadius: "10px",
        padding: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: isOpen ? "1px solid gray" : "",
          paddingBottom: isOpen ? "8px" : "",
          transition: "padding 0.2s ease",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",

            gap: "4px",
          }}
        >
          <img width={32} src={identityDocuments} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              تصاویر مدارک
            </Typography>
            <Typography>کارت ملی، کارت هوشمند، گواهینامه</Typography>
          </Box>
        </Box>
        <Button
          onClick={() => toggleBox()}
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid gray",
            minWidth: "0px !important",
            height: "fit-content",
            padding: "10px 8px",
            gap: "4px",
            borderColor: isOpen
              ? `${theme.palette.error.main} !important`
              : `${theme.palette.secondary.main} !important`,
            backgroundColor: isOpen
              ? `${theme.palette.error.light} !important`
              : `${theme.palette.secondary.light} !important`,
            "& .MuiTouchRipple-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
            },
            "& .MuiButtonBase-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
              minWidth: "0px !important",
            },
            "& .MuiButton-root": {
              minWidth: "0px !important",
            },
          }}
        >
          {isOpen ? (
            <Typography
              sx={{
                color: isOpen ? "error.main" : "secondary.main",
                fontSize: "12px",
                fontWeight: "600",
                whiteSpace: "nowrap",
              }}
            >
              بستن جزئیات
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "600",
                color: isOpen ? "error.main" : "secondary.main",
                whiteSpace: "nowrap",
              }}
            >
              مشاهده/ویرایش{" "}
            </Typography>
          )}
          <ArrowDownSVG
            size={14}
            color={
              isOpen ? theme.palette.error.main : theme.palette.secondary.main
            }
          />
        </Button>
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1500px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "6px",
        }}
      >
        <Box
          sx={{
            mt: 1,
            backgroundColor: "primary.light",
            borderRadius: "8px",
            padding: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DangerFill color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              توجه:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
            }}
          >
            در صورت ارسال عکس جدید از مدارک، حساب شما به حالت احرازنشده تبدیل
            می‌شود تا اپراتور بازارگاه مدارک را تایید کند.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            paddingY: "16px",
            // border: "1px solid gray",
          }}
        >
          <DocumentCard />
          <DocumentCard />
          <DocumentCard />
          <DocumentCard />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <CheckCircle size={24} color={theme.palette.success.main} />
          <Typography
            sx={{
              color: "success.main",
            }}
          >
            برای اعمال شدن تغییرات حتما ذخیره اطلاعات را بزنید
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 1,
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Button
            onClick={() => toggleBox()}
            sx={{
              flex: "1",
              display: "flex",
              borderRadius: "6px",
              alignItems: "center",
              border: "1px solid gray",
              minWidth: "0px !important",
              height: "fit-content",
              padding: "10px 8px",
              gap: "4px",
              borderColor: `${theme.palette.primary.main} !important`,
              backgroundColor: `${theme.palette.primary.light} !important`,
              "& .MuiTouchRipple-root": {
                color: `#fff !important`,
                borderWidth: "0px !important",
              },
              "& .MuiButtonBase-root": {
                color: `${theme.palette.error.main} !important`,
                borderWidth: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiButton-root": {
                minWidth: "0px !important",
              },
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "12px",
                whiteSpace: "nowrap",
              }}
            >
              انصراف{" "}
            </Typography>
          </Button>
          <Button
            //   onClick={() => toggleBox()}
            sx={{
              flex: "1",
              display: "flex",
              borderRadius: "6px",
              alignItems: "center",
              //   border: "1px solid gray",
              minWidth: "0px !important",
              height: "fit-content",
              padding: "10px 8px",
              gap: "4px",
              //   borderColor: `${theme.palette.secondary.main} !important`,
              backgroundColor: `${theme.palette.primary.main} !important`,
              "& .MuiTouchRipple-root": {
                color: `#fff !important`,
                borderWidth: "0px !important",
              },
              "& .MuiButtonBase-root": {
                color: `${theme.palette.error.main} !important`,
                borderWidth: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiButton-root": {
                minWidth: "0px !important",
              },
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: "12px",
                whiteSpace: "nowrap",
              }}
            >
              ذخیره اطلاعات{" "}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
